import './Remark.style.less'

function Remark() {
  return (
    <div className="remark-container">
      <p>
        Remark: Findings under Subject to Customer&apos;s Decision are those
        actual findings, not related to safety or legal requirement, where a
        clear customer specification is missing, shall be reported to customer
        to decide on the acceptance.
      </p>

      <p>
        DISCLAIMER: This reflects our findings at the time and place of
        inspection based on comparison of inspection applicant&apos;s
        information/sample with random samples in accordance with a previously
        agreed random statistical sampling standard. This report does not
        discharge or release sellers / suppliers from their commercial legal or
        contractual obligations with regard to quality/quantity of delivery nor
        does it prejudice the buyer&apos;s right of claim towards
        sellers/suppliers for compensation for an apparent/or hidden defects not
        detected during our random inspection or occurring thereafter. This
        report does not evidence shipment.
      </p>
    </div>
  )
}

export default Remark
